import { Button } from '@/components/ui/Button';
import { Link } from 'gatsby';
import { isEmpty } from 'lodash';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import getUserAction from '../../../app/redux/actions/getUserAction';
import updateLastAction from '../../../app/redux/actions/updateLastAction';
import { getProfileDetails } from '../../../app/redux/features/profile/getProfileDetails';
import { useAppDispatch, useAppSelector } from '../../../app/redux/hooks';
import { CompleteProfile } from './MatchBody';
import { useUserMatches } from './hooks/UseUserMatches';

interface MatchesStatesProps extends React.HTMLAttributes<HTMLDivElement> {
  user: any;
  getUser: Function;
  complete?: boolean;
  notFound?: boolean;
}

const MatchesStates = ({ user, getUser, complete, notFound }: MatchesStatesProps) => {
  const dispatch = useAppDispatch();
  const profile = useAppSelector((state) => state.profile?.profile);
  const { numMatches } = useUserMatches();
  const introCount = user ? parseInt(localStorage.getItem(`MatchesShowIntro_${user?.id}`) ?? '0') : 0;
  const showCaughtUp = introCount === 2 || numMatches > 0;

  useEffect(() => {
    if (isEmpty(user)) {
      getUser();
    }
    if (isEmpty(profile)) {
      dispatch(getProfileDetails());
    }
  }, []);

  const title = complete ? "You're all caught up" : notFound ? "We can't find your match" : null;
  const paragraph = complete
    ? 'Head to your dashboard to review your matches'
    : notFound
    ? 'Unfortunately the match you are looking for no longer exists or its deadline has expired.'
    : null;

  return (
    <>
      <div className="flex flex-col space-y-3 place-items-center">
        <div className="flex justify-center">
          <div className="uppercase bg-shock-700 inline-flex mb-8 px-3 py-1 rounded-lg space-x-1.5 items-center mt-2 mr-2 flex-shrink-0 text-xxs font-semibold">
            Your inbox is empty
          </div>
        </div>
        {showCaughtUp && (
          <>
            {title && <h1 className="display-title-2xl text-center">{title}</h1>}
            {paragraph && <p className="text-center leading-7 text-sm max-w-[23rem]">{paragraph}</p>}
            <Button asChild appearance="primary" size={'sm'}>
              <Link to="/dashboard/saved" data-cy={`link:view-account`}>
                View dashboard
              </Link>
            </Button>
          </>
        )}
      </div>
      {!isEmpty(user) && <CompleteProfile user={user} />}
    </>
  );
};

const mapStateToProps = ({ auth }: any) => {
  return {
    user: auth.user
  };
};

const mapDispatchToProps = {
  getUser: getUserAction,
  updateAction: updateLastAction
};

export default connect(mapStateToProps, mapDispatchToProps)(MatchesStates);
